export const FilterConstants = {
    FILTER_ARRAY_DELIMITER: '\n',
    MAX_GET_URL_LENGTH: 8000,
    // поля-периоды (календарь): без выбора оператора, значение — период «от@до»
    DATE_RANGE_TYPES: ['dateRange', 'unixDateRange'],
}
